import { 
  Users, 
  Fire, 
  Target, 
  CalendarCheck,
  ArrowSquareOut
} from "@phosphor-icons/react";

const KPICard = ({ label, value, icon: Icon, color, loading, testId }) => (
  <div 
    className="kpi-card"
    data-testid={testId}
  >
    <div className="flex items-center justify-between mb-3">
      <span 
        className="text-xs uppercase tracking-[0.2em] text-[#A0A0A0]"
      >
        {label}
      </span>
      <Icon 
        size={24} 
        weight="bold"
        style={{ color }}
        className="opacity-80"
      />
    </div>
    <div 
      className="font-mono text-5xl font-black tracking-tighter text-white"
    >
      {loading ? "—" : value}
    </div>
  </div>
);

const KPIHeader = ({ kpis, loading }) => {
  const kpiConfig = [
    {
      key: "total_sessions",
      label: "Total Sessions Today",
      value: kpis.total_sessions_today,
      icon: Users,
      color: "#007AFF",
      testId: "kpi-total-sessions"
    },
    {
      key: "hot_leads",
      label: "Hot Leads Today",
      value: kpis.hot_leads_today,
      icon: Fire,
      color: "#FF3B30",
      testId: "kpi-hot-leads"
    },
    {
      key: "converted_leads",
      label: "Converted Today",
      value: kpis.converted_leads_today,
      icon: Target,
      color: "#32D74B",
      testId: "kpi-converted-leads"
    },
    {
      key: "demo_bookings",
      label: "Demo Bookings Today",
      value: kpis.demo_bookings_today,
      icon: CalendarCheck,
      color: "#32D74B",
      testId: "kpi-demo-bookings"
    },
    {
      key: "handoffs_sent",
      label: "Handoffs Sent Today",
      value: kpis.handoffs_sent_today,
      icon: ArrowSquareOut,
      color: "#BF5AF2",
      testId: "kpi-handoffs-sent"
    }
  ];

  return (
    <div 
      className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8"
      data-testid="kpi-header"
    >
      {kpiConfig.map(kpi => (
        <KPICard
          key={kpi.key}
          label={kpi.label}
          value={kpi.value}
          icon={kpi.icon}
          color={kpi.color}
          loading={loading}
          testId={kpi.testId}
        />
      ))}
    </div>
  );
};

export default KPIHeader;
